import { Link } from 'gatsby';
import React, { useState } from 'react';
import renderLink from '~/utils/render-link';

function SocialIconAlt({ type = 'facebook', url = '#', invert = false }) {
  const [onHover, setOnHover] = useState(false);

  // I know this is horrendous, but it was driving me insane trying to figure it out
  const colorFill = (invert === 'true') ? '#FFFFFF' : '#0F0F0F'

  return (
    <div>
      <a href={renderLink(url)} className="group" target="_blank" rel="noreferrer">
        <div
          className="flex items-center justify-center w-10 h-10 transition-opacity duration-300 group hover:opacity-50"
          onMouseEnter={() => setOnHover(true)}
          onMouseLeave={() => setOnHover(false)}
        >
          {type === 'youtube' ? (
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.8667 3.0001C15.8667 3.0001 15.7333 1.86676 15.2 1.4001C14.6 0.733431 13.9333 0.733431 13.6 0.733431C11.3333 0.600098 8 0.600098 8 0.600098C8 0.600098 4.66667 0.600098 2.4 0.733431C2.06667 0.800098 1.4 0.800098 0.8 1.4001C0.333333 1.86676 0.133333 3.0001 0.133333 3.0001C0.133333 3.0001 0 4.26676 0 5.6001V6.8001C0 8.06676 0.133333 9.4001 0.133333 9.4001C0.133333 9.4001 0.266667 10.5334 0.8 11.0001C1.4 11.6668 2.2 11.6001 2.53333 11.6668C3.8 11.8001 8 11.8001 8 11.8001C8 11.8001 11.3333 11.8001 13.6 11.6001C13.9333 11.5334 14.6 11.5334 15.2 10.9334C15.6667 10.4668 15.8667 9.33343 15.8667 9.33343C15.8667 9.33343 16 8.06677 16 6.73343V5.53343C16 4.26676 15.8667 3.0001 15.8667 3.0001ZM6.33333 8.26676V3.8001L10.6667 6.06676L6.33333 8.26676Z"
                fill={colorFill}
              />
            </svg>
          ) : type === 'mail' ? (
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.3948 7.40158L19.1423 0.401692C18.9048 0.305858 18.6506 0.255859 18.3948 0.255859H2.39482C2.13815 0.256693 1.88399 0.306693 1.64648 0.404192L10.3948 7.40158Z" />
              <path d="M10.8112 8.77654C10.5679 8.97154 10.2212 8.97154 9.97787 8.77654L0.644537 1.30987C0.48287 1.59904 0.397027 1.92403 0.394531 2.2557V12.9224C0.397031 14.0257 1.29119 14.9199 2.39453 14.9224H18.3945C19.4979 14.9199 20.392 14.0257 20.3945 12.9224V2.2557C20.392 1.92403 20.3062 1.59738 20.1445 1.30737L10.8112 8.77654Z" />
            </svg>
          ) : type === 'linkedin' ? (
            <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0)">
                <path
                  d="M16.245.39H1.615c-.4 0-.7.29-.7.68v14.287c0 .292.3.583.7.583h14.73c.4 0 .701-.291.701-.68V1.07c-.1-.39-.4-.68-.801-.68zM5.623 13.606H3.32V6.221h2.405v7.386h-.1zM4.521 5.25c-.801 0-1.403-.68-1.403-1.36 0-.778.602-1.362 1.403-1.362.802 0 1.403.584 1.403 1.361-.1.68-.701 1.36-1.403 1.36zm10.02 8.358h-2.405v-3.596c0-.874 0-1.944-1.202-1.944s-1.403.972-1.403 1.944v3.694H7.126V6.22h2.305v.972c.3-.583 1.102-1.167 2.205-1.167 2.404 0 2.805 1.555 2.805 3.5v4.082h.1z"
                  fill={colorFill}
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <path fill={colorFill} transform="translate(.914 .39)" d="M0 0H16.032V15.551H0z" />
                </clipPath>
              </defs>
            </svg>
          ) : type === 'instagram' ? (
            <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.672 5.412c.517 0 .937-.375.937-.839 0-.463-.42-.839-.937-.839-.518 0-.938.376-.938.84 0 .463.42.838.938.838zM8.627 12.22c-2.153 0-3.904-1.694-3.904-3.776 0-2.083 1.751-3.777 3.904-3.777 2.154 0 3.905 1.694 3.905 3.777 0 2.082-1.751 3.776-3.905 3.776zm0-5.664c-1.076 0-1.952.846-1.952 1.888 0 1.041.876 1.888 1.952 1.888 1.077 0 1.953-.847 1.953-1.888 0-1.042-.876-1.888-1.953-1.888z"
                fill={colorFill}
              />
              <path
                d="M12.53 15.94H4.722c-2.007 0-3.905-1.89-3.905-3.888V4.277C.816 2.279 2.714.389 4.721.389h7.81c2.007 0 3.905 1.89 3.905 3.888v7.775c0 1.999-1.898 3.888-3.905 3.888zM4.722 2.333c-.913 0-1.952 1.035-1.952 1.944v7.775c0 .927 1.022 1.944 1.952 1.944h7.81c.913 0 1.952-1.035 1.952-1.944V4.277c0-.909-1.04-1.944-1.952-1.944H4.72z"
                fill={colorFill}
              />
            </svg>
          ) : (
            type === 'facebook' && (
              <svg width="12" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.866 17.342l-.025-7.77H.637V6.466H3.84V4.523C3.84 1.639 5.68.249 8.334.249c1.27 0 2.362.092 2.68.133v3.014h-1.84c-1.442 0-1.721.665-1.721 1.64v1.429h4.197l-1.602 3.108H7.453v7.77H3.866z"
                  fill={colorFill}
                />
              </svg>
            )
          )}
        </div>
      </a>
    </div>
  );
}

export default SocialIconAlt;
